import axios from "../../js/project-axios.js"

const uploadPhoto = file => {
    let formData = new FormData();
    formData.append("file", file)
    return axios.post("/asset/common/uploadPhoto", formData, {
        timeout: 120000 // 2分钟 
    });
};

const getPhoto = code => {
    return axios.get("/asset/common/getPhoto", {
        params: {
            code
        }
    });
};

export default {
    uploadPhoto,
    getPhoto
};